import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/hand-point-left': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M0 220.8c0-45.1 38.1-83.2 83.2-83.2h86.2c-1.4-6.9-2.2-14.4-2.2-22.4 0-47.9 35.1-83.2 92-83.2 45.3 0 57 48.5 75.7 78.8 7.7 12.4 17 23.3 25.9 33.3l0.1 0.1 0.1 0.1c15.3 17.5 23.2 23.7 30.2 23.7h2.7c5.7-5 13.5-8 22.1-8h64c17.7 0 32 12.9 32 28.8v230.4c0 15.9-14.3 28.8-32 28.8h-64c-8.6 0-16.4-3-22.1-8h-2.7c-28.7 0-67.1 40-127.2 40h-21.3c-62.5 0-98.8-38.7-99.9-91.1-12.5-17.8-18.5-40.8-16-62.8-3-5.8-6.5-15.7-7.9-22.1h-35.6c-45.4 0-83.2-37.6-83.2-83.2zM48 220.8c0 19 16.2 35.2 35.2 35.2h91c-12.8 14.7-14.4 42.8 5 61-11.2 19.6-1.7 45.6 12.9 53.6-6.5 39.1 10.1 61.3 50.6 61.3h21.3c45.5 0 77.2-35.9 120-39.7v-176.8c-25.2-3-43-21.2-59.1-39.6-11.3-12.6-21.7-25.3-30.8-39.9-14.5-23.4-26.1-56.1-34.9-56.1-23.4 0-44 8.8-44 35.2 0 35.2 26.4 53.1 26.4 70.4h-158.4c-18.4 0-35.2 16.5-35.2 35.2zM448 360c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/hand-point-left.js
// module id = 1767
// module chunks = 0